(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tc-delivery-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tc-delivery-countdown')) {
    customElements.define(
      'tc-delivery-countdown',
      class TcDeliveryCountdown extends HTMLElement {
        connectedCallback() {
          this.output = this.querySelector('.tc-delivery-note__countdown-text');
          this.hidden = false;
          this.render();
          this.timer = setInterval(() => this.render(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        /* Current wall-clock time in the configured timezone, as a plain Date. */
        localNow() {
          const timezone = this.dataset.timezone;
          const now = new Date();
          if (!timezone) return now;
          try {
            return new Date(now.toLocaleString('en-US', { timeZone: timezone }));
          } catch (error) {
            return now;
          }
        }

        render() {
          const now = this.localNow();
          const cutoff = new Date(now);
          cutoff.setHours(
            parseInt(this.dataset.cutoffHour, 10) || 0,
            parseInt(this.dataset.cutoffMinute, 10) || 0,
            0,
            0
          );

          const day = now.getDay();
          const isWeekend = this.dataset.weekdaysOnly === 'true' && (day === 0 || day === 6);
          const remaining = cutoff - now;

          if (isWeekend || remaining <= 0) {
            this.output.innerHTML = this.dataset.after || '';
            this.hidden = !this.dataset.after;
            return;
          }

          const totalSeconds = Math.floor(remaining / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const pad = (value) => String(value).padStart(2, '0');
          const clock = hours > 0 ? `${hours}h ${pad(minutes)}m ${pad(seconds)}s` : `${minutes}m ${pad(seconds)}s`;

          this.output.innerHTML = (this.dataset.before || '{time}').replace('{time}', `<strong>${clock}</strong>`);
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
